<template>
  <v-layout wrap v-if="embedded">
      <v-flex class="table-doc-embedded">
          <v-text-field
            v-if="fieldData"
            @click.stop="viewFile()"
            box readonly
            :value="filename"
            :label="fieldLabel"
            class="document-link">
            <template slot="append" v-if="filename">

              <v-flex shrink fill-height class="vert-dots" v-if="!readonly">
                <v-menu
                  nudge-top="30px"
                  left
                  offset-y
                  origin="center center"
                  transition="scale-transition"
                >
                  <v-btn
                    flat
                    slot="activator"
                    icon
                    class="ma-0 pa-0"
                    dark
                    color="secondary"
                  >
                    <v-icon>more_vert</v-icon>
                  </v-btn>
                  <v-list dense>
                    <v-list-tile v-if="openable" @click="viewFileToSide()">
                      <v-icon class="mr-2" color="secondary">vertical_split</v-icon>
                      Open to the side
                    </v-list-tile>
                    <v-list-tile  v-if="openable" @click="viewFile()">
                      <v-icon class="mr-2" color="secondary">open_in_browser</v-icon>
                      Open in new tab
                    </v-list-tile>
                    <v-list-tile @click="viewInDocumentsTab()">
                      <v-icon class="mr-2" color="secondary">insert_drive_file</v-icon>
                      View on Documents Tab
                    </v-list-tile>
                    <v-list-tile @click="viewFile(true)">
                      <v-icon class="mr-2" color="secondary">file_download</v-icon>
                      Download
                    </v-list-tile>
                    <v-list-tile @click="clearField()">
                      <v-icon class="mr-2" color="error">cancel</v-icon>Clear Field
                    </v-list-tile>
                  </v-list>
                </v-menu>
              </v-flex>

            </template>
          </v-text-field>
        <p class="d-inline-block btn" v-if="!fieldData && !readonly">
          <AttachmentsDialog
            v-if="isEmpty"
            :attachments="attachments"
            :selectedAttachments="selectedAttachments"
            v-on:selected-file-attachment="selectFileAttachment"
            :allow-select-multiple="allowSelectMultiple"
            :currentCase="currentCase"
            :user="user"/>
          <span class="d-inline-block" style="vertical-align: middle; text-transform: uppercase;margin-top: 12px !important;">Add {{fieldLabel}}</span>
        </p>
        <p v-if="readonly" class="mt-4 text-xs-center grey--text">No Files Selected.</p>
      </v-flex>
  </v-layout>
  <v-layout wrap v-else>
    <v-flex xs12 class="document-field-container">
      <span v-if="field" class="text-xs-center grey--text">{{fieldLabel}}</span>
      <v-card
        flat class="px-3 pt-4 mb-0" :style="cardStyle"
        color="transparent">
        <div v-if="fieldData && fieldData.filename" class="documents">
          <document-icon
            :filename="filename"
            :filetype="fileType"
            :route="route"
            :readonly="readonly"
            :currentlySelected="currentlySelected"
            v-on:view-file="viewFile()"
            v-on:view-file-to-side="viewFileToSide()"
            v-on:view-in-documents-tab="viewInDocumentsTab()"
            v-on:send-file="moveFile()"
            v-on:copy-file="openCopy()"
            v-on:download-file="viewFile(true)"
            v-on:rename-file="openRename()"
            v-on:delete-file="removeFile()"
            v-on:clear-field="clearField()" is-field>
          </document-icon>
        </div>
        <div v-if="!(fieldData && fieldData.filename)" class="documents">
          <p class="text-xs-center grey--text">
            <AttachmentsDialog
              v-if="isEmpty && !readonly"
              :attachments="attachments"
              :selectedAttachments="selectedAttachments"
              v-on:selected-file-attachment="selectFileAttachment"
              :allow-select-multiple="allowSelectMultiple"
              :currentCase="currentCase"
              :user="user"/>
            No files selected.
          </p>
        </div>
      </v-card>
    </v-flex>
    <v-dialog v-model="renameDialog" width="500">
      <v-card class="pa-4">
        <v-card-title class="ma-0 mb-2 pa-0">
          <h2>Rename File</h2>
        </v-card-title>
        <v-card-text class="ma-0 mt-2 mb-1 pa-0">
          <v-text-field v-model="newfilename" class="white-box-field" label="Filename" box></v-text-field>
        </v-card-text>
        <v-card-actions class="ma-0 mt-3 pa-0">
          <v-btn @click="renameFile()" color="success">
            Save changes
          </v-btn>
          <v-btn @click="cancelRename()" id="bucket-delete-dialog-cancel-btn" color="secondary">
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="copyDialog" width="500">
      <v-card class="pa-4">
        <v-card-title class="ma-0 mb-2 pa-0">
          <h2>Duplicate File</h2>
        </v-card-title>
        <v-card-text class="ma-0 mt-2 mb-1 pa-0">
          <v-text-field v-model="newfilename" class="white-box-field" label="Filename" box></v-text-field>
        </v-card-text>
        <v-card-actions class="ma-0 mt-3 pa-0">
          <v-btn @click="copyFile()" color="success">
            Save changes
          </v-btn>
          <v-btn @click="cancelCopy()" id="bucket-delete-dialog-cancel-btn" color="secondary">
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { mapState } from "vuex"
import Helpers from "@/helpers.js"
import DocumentIcon from "@/components/cases/case-elements/DocumentIcon.vue"

export default {
  name: "DocumentField",
  props: {
    field: {
      type: Object
    },
    data: {
      type: Object
    },
    allowSelectMultiple: {
      type: Boolean,
      default: false
    },
    embedded: {
      type: Boolean,
      default: false
    },
    row: {
      type: Number
    }
  },
  components: {
    DocumentIcon,
    AttachmentsDialog: () => import('@/components/cases/case-elements/AttachmentsDialog.vue')
  },
  data: () => {
    return {
      newfilename: "",
      renameDialog: false,
      copyDialog: false,
      viewing: false,
      embeddedData: undefined
    }
  },
  created() {
    if (!this.fileExists) { // Check if file has been deleted from attachments first..
      this.$emit('update-item', { field: this.field.name, data: undefined, row: this.row }) // Clear field data
    }
  },
  computed: {
    ...mapState({
      user: state => state.currentUser,
      currentAccount: state => state.currentUser.account,
      currentCaseType: state => state.caseTypes.current,
      currentCase: state => state.cases.currentlySelected.case,
      currentPath: state => state.cbroute.path,
      selectedAttachments: state => state.folders.selectedAttachments
    }),
    fieldData() {
      if (this.embeddedData) {
        return this.embeddedData
      } else {
        return this.data
      }
    },
    attachments() {
      if (this.currentCase && this.currentCase.fileAttachments) {
        return this.currentCase.fileAttachments
      } else {
        return []
      }
    },
    isEmpty() {
      return !(this.fieldData && this.fieldData.url)
    },
    fieldLabel() {
      return (this.field.display_name) ? this.field.display_name : Helpers.capitalizeRemoveUnderscores(this.field.name)
    },
    currentlySelected() {
      const expected = "/case/" + this.currentCase.id + "/details"
      return this.currentPath === expected
    },
    fileExists() {
      if (this.fieldData && this.fieldData.id) {
        const attachmentIds = this.attachments.map(file => file.id)
        return attachmentIds.includes(this.fieldData.id)
      } else {
        return false
      }
    },
    filename() {
      if (this.fieldData) {
        if (this.fieldData.filename) {
          return this.fieldData.filename
        } else {
          return this.fieldData.filename
        }
      } else { return "Document.pdf" }
    },
    fileType() {
      if (this.fieldData) { return this.fieldData.extension } else { return "pdf" }
    },
    openable() {
      switch (this.fileType.toLowerCase()) {
        case ".bmp":
        case ".gif":
        case ".jpg":
        case ".jpeg":
        case ".svg":
        case ".png":
        case ".pdf":
          return true
        default:
          return false
      }
    },
    route() {
      if (this.fieldData) { return this.fieldData.url } else { return "/" }
    },
    id() {
      if (this.fieldData) { return this.fieldData.id }
      return undefined
    },
    cardStyle() {
      if (this.field) {
        return "background-color:rgba(0,0,0,0.06) !important; border-top-left-radius: 4px; border-top-right-radius: 4px; !important; border-bottom:1px solid rgba(0,0,0,0.22) !important"
      } else {
        return ""
      }
    },
    readonly() {
      let readonly = false
      if (this.field && this.field.readonly) { readonly = this.field.readonly }
      return readonly
    }
  },
  methods: {
    selectFileAttachment(attachment) {
      this.$emit('update-item', { field: this.field.name, data: attachment, row: this.row })
      this.$emit("blurred", {
        field: this.field.name,
        data: attachment,
        row: this.row
      })
      if (this.embedded) {
        this.embeddedData = attachment
      }
    },
    moveFile() {
      console.log("Move selected for file: " + this.filename + "(" + this.id + ")")
      // this.$store.dispatch("moveCaseDocument", { fileAttachmentId: this.id })
    },
    openCopy() {
      this.newfilename = this.filename
      this.copyDialog = true
    },
    cancelCopy() {
      this.newfilename = ""
      this.copyDialog = false
    },
    async copyFile() {
      const newFolderLocation = '/'
      const newFilePath = `/${this.newfilename}`

      if (this.id && this.newfilename) {
        const result = await this.$store.dispatch("copyCaseDocument", {
          fileAttachmentId: this.id,
          newFilePath,
          newFolderLocation
        })
        if (result) this.closeDialogs()
      } else {
        this.$store.commit("displayFlashMessage", { message: 'Failed to copy: Invalid file', severity: "error" })
      }
    },
    clearField() {
      this.$emit('update-item', { field: this.field.name, data: undefined, row: this.row })
      this.$emit("blurred", {
        field: this.field.name,
        data: undefined,
        row: this.row
      })
      if (this.embedded) {
        this.embeddedData = undefined
      }
    },
    async viewFile(download = false) {
      try {
        if (!this.viewing) {
          this.viewing = true
          const query = (download) ? '?isDownload=true' : ''
          const url = window.location.href.startsWith("http://localhost") ? `http://localhost:6543${this.fieldData.url}${query}` : `${this.fieldData.url}${query}`
          const auth = 'Bearer ' + window.localStorage.session

          const anchor = document.createElement("a")
          document.body.appendChild(anchor)
          const headers = new Headers()
          headers.append("Authorization", auth)

          const response = await fetch(url, { headers })
          const blobby = await response.blob()
          const objectUrl = window.URL.createObjectURL(blobby)
          anchor.href = objectUrl
          if (download) {
            anchor.download = this.fieldData.filename
          } else {
            anchor.target = "blank"
          }
          anchor.click()
          this.viewing = false
        }
      } catch (err) {
        console.log(err)
        this.$store.commit("displayFlashMessage", { message: `Failed to view/download file `, severity: "error" })
      }
    },
    viewFileToSide() {
      this.$store.dispatch('viewFileToSide', { field: this.field, fileAttachment: this.fieldData })
    },
    viewInDocumentsTab() {
      const docRoot = `/documents/${this.currentAccount.id}/${this.currentCaseType.id}/${this.currentCase.id}/`
      const fullPath = this.fieldData.url.replace(docRoot, '') // get document path

      if (fullPath === this.fieldData.filename) {
        // file is on root level
        this.$router.push({ name: "CaseDocuments", params: { case_id: this.currentCase.id } })
      } else {
        const folderPath = fullPath.replace(`/${this.fieldData.filename}`, '')
        this.$router.push({ name: "CaseDocuments", params: { case_id: this.currentCase.id, path_navigation: folderPath } })
      }
    },
    openRename() {
      this.newfilename = this.filename
      this.renameDialog = true
    },
    closeDialogs() {
      this.newfilename = ""
      this.copyDialog = false
      this.renameDialog = false
    },
    renameFile() {
      // should use moveCaseDocument instead?
      this.$store.dispatch("renameCaseDocument", { fileAttachmentId: this.id, newFileName: this.newfilename, caseId: parseInt(this.currentCase.id) })
      this.closeDialogs()
    },
    removeFile() {
      if (this.currentlySelected) {
        this.$emit('update-item', { field: this.field.name, data: undefined, row: this.row }) // Clear field data
      } else {
        this.$store.dispatch("deleteCaseDocument", { fileAttachmentId: this.id, caseId: parseInt(this.currentCase.id) })
      }
    },
    sendUpdate() {
      if (this.filename && this.extension && this.url) {
        const output = {
          contentType: "application/" + this.fileType,
          extension: this.fileType,
          filename: this.filename,
          size: this.size,
          status: this.status,
          createdAt: this.createdAt,
          updatedAt: this.updatedAt,
          url: this.url,
          used_as_attachment: this.isAttachment
        }
        this.$emit('update-item', { field: this.field.name, data: output, row: this.row })
      }
    }
  }
}
</script>

<style>
.document-link input{
  min-width:180px;
  text-decoration: underline;
}
.document-link:hover input {
  cursor:pointer;
}
.document-link .v-btn {
  margin-top: -3px !important;
}

.document-field-container {
  margin-bottom: 20px;
  border-radius: 5px;
}
</style>
